import type { HelpPageKey } from './helpPageMapping';

export type AgentIntentOption = { id: string; label: string; prompt: string };

/** Actions hidden from quick-intent pickers and agent reply buttons in the UI. */
export const HIDDEN_AGENT_ACTION_IDS = new Set([
  'guide_run',
  'run_request_by_request',
  'run_round_robin',
  'run_full_flow',
]);

/** Curated list for the intent picker; `prompt` must match `interpretAgentShortcut` rules. */
export const AGENT_INTENT_OPTIONS: AgentIntentOption[] = [
  { id: 'create_select', label: 'Create or select project', prompt: 'create or select project' },
  { id: 'create_environment', label: 'Create environment', prompt: 'create environment' },
  { id: 'import_swagger', label: 'Import Swagger / OpenAPI', prompt: 'import swagger' },
  { id: 'env_variable', label: 'Add environment variable', prompt: 'add environment variable' },
  {
    id: 'apply_env_to_request',
    label: 'Apply environment variables to request',
    prompt: 'apply environment variables to selected request',
  },
  { id: 'execute_request', label: 'Execute request', prompt: 'execute request' },
  {
    id: 'copy_request_to_all_collections',
    label: 'Copy request to all collections',
    prompt: 'copy request to all collections',
  },
  { id: 'set_login_credentials', label: 'Set login credentials', prompt: 'set login credentials' },
  { id: 'create_function', label: 'Create custom function', prompt: 'create custom function' },
  { id: 'run_function', label: 'Run function', prompt: 'run function' },
  { id: 'apply_ordering', label: 'Apply suggested ordering', prompt: 'apply suggested ordering' },

  { id: 'default_headers', label: 'Apply default headers', prompt: 'apply default headers' },
  { id: 'bearer', label: 'Apply Bearer token to requests', prompt: 'apply bearer token to requests' },
  { id: 'suggest_assertions', label: 'Generate suggested assertions', prompt: 'suggested assertion' },
  {
    id: 'diagnose_proxy',
    label: 'Diagnose proxy connection',
    prompt: 'diagnose proxy connection',
  },
];

export function buildAgentWidgetQuickActions(pageKey: HelpPageKey): AgentIntentOption[] {
  if (pageKey === 'COLLECTIONS') {
    const execute = AGENT_INTENT_OPTIONS.find((o) => o.id === 'execute_request');
    const rest = AGENT_INTENT_OPTIONS.filter((o) => o.id !== 'execute_request');
    return execute ? [execute, ...rest] : [...AGENT_INTENT_OPTIONS];
  }

  if (pageKey === 'ENVIRONMENTS') {
    const createEnv = AGENT_INTENT_OPTIONS.find((o) => o.id === 'create_environment');
    const rest = AGENT_INTENT_OPTIONS.filter((o) => o.id !== 'create_environment');
    return createEnv ? [createEnv, ...rest] : [...AGENT_INTENT_OPTIONS];
  }

  return [...AGENT_INTENT_OPTIONS];
}

export function defaultAgentWidgetQuickActionId(pageKey: HelpPageKey): string {
  if (pageKey === 'COLLECTIONS') return 'execute_request';
  if (pageKey === 'ENVIRONMENTS') return 'create_environment';
  return '';
}
